import { ChangeEvent, createElement, FC, useState } from 'react';
import { Edit, Save } from 'react-feather';
import styled from 'styled-components';
import { Button, StyledInput } from '.';

interface Props {
  headingType?: string;
  maxButtonWidth?: string;
  minButtonWidth?: string;
  width?: string;
  title: string;
  handleTitleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const EditableTitle: FC<Props> = ({ headingType, maxButtonWidth, minButtonWidth, width, title, handleTitleChange }) => {
  const [editing, setEditing] = useState(false);

  const toggleEditing = () => setEditing(!editing);

  return (
    <Title style={{ ...(width && { width }) }}>
      {headingType &&
        createElement(
          headingType,
          { styles: { flex: '1 0', marginRight: '0.3em' } },
          editing ? <StyledInput type="text" value={title} onChange={handleTitleChange} /> : title
        )}
      <Button
        type="button"
        icon={editing ? <Save /> : <Edit />}
        text={editing ? 'Save Title' : 'Edit Title'}
        maxWidth={maxButtonWidth}
        minWidth={minButtonWidth}
        onClick={toggleEditing}
      />
    </Title>
  );
};

EditableTitle.defaultProps = {
  headingType: 'h1',
  maxButtonWidth: '150px',
  minButtonWidth: '150px',
};

export default EditableTitle;
